import { ADD_SUBSCRIPTION_ERROR, ADD_SUBSCRIPTION_REQUEST, ADD_SUBSCRIPTION_SUCCESS, } from '../types';
import { useHelper } from '../helpers';
export const addSubscriptionRequest = (sku) => {
    return {
        type: ADD_SUBSCRIPTION_REQUEST,
        sku,
    };
};
export const addSubscriptionSuccess = (cart, lineItem, subscriptionLineItem) => {
    return {
        type: ADD_SUBSCRIPTION_SUCCESS,
        data: cart,
        lineItem,
        subscriptionLineItem,
    };
};
export const addSubscriptionError = (error, meta = {}) => {
    return {
        type: ADD_SUBSCRIPTION_ERROR,
        error: true,
        meta,
        payload: error,
    };
};
export const addSubscription = (subscription) => {
    return async (dispatch, getState, { chord }) => {
        const { withCart } = useHelper(dispatch, getState);
        const { sku, quantity, interval, endDate } = subscription;
        try {
            dispatch(addSubscriptionRequest(sku));
            const input = {
                lineItem: {
                    sku,
                    quantity,
                },
                subscriptionLineItem: {
                    intervalLength: interval.length,
                    intervalUnits: interval.unit,
                    endDate,
                },
            };
            await withCart(chord.oms.addLineItem)(null, input);
            const updatedCart = await withCart(chord.oms.getOrder)();
            const lineItem = updatedCart.lineItems.find((li) => li.variant.sku === sku);
            const subscriptionLineItem = lineItem.subscriptionLineItems.at(-1);
            dispatch(addSubscriptionSuccess(updatedCart, lineItem, subscriptionLineItem));
            return updatedCart;
        }
        catch (error) {
            dispatch(addSubscriptionError(error, {
                sku,
                quantity,
                interval,
                endDate,
            }));
            throw error;
        }
    };
};
